import {
  announcementMessageMaxSize,
  setIsAnnouncementsRequested,
  type Announcement,
} from '../../../Store/DataSlice'
import './AnnouncementAdd.scss'
import { useEffect, useState } from 'react'
import { TextInput } from '../../../Components/TextInput/TextInput'
import { useLocalization } from '../../../Hooks/useLocalization'
import { Button } from '../../../Components/Button/Button'
import { useDispatch } from 'react-redux'
import { setDestinationView } from '../../../Store/InterfaceSlice'
import { getAuthorizationHeader } from '../../../Orchestration/Authentication'
import { LoadingSpinner } from '../../../Components/LoadingSpinner/LoadingSpinner'
import uuid4 from 'uuid4'
import { DateInput } from '../../../Components/DateInput/DateInput'
import { HtmlTextInput } from '../../../Components/HtmlTextInput/HtmlTextInput'

const emptyAnnouncement: Announcement = {
  uuid: '',
  date: 0,
  title: '',
  message: '',
}

export function AnnouncementAdd() {
  const dispatch = useDispatch()
  const localization = useLocalization('announcement')

  const [announcement, setAnnouncement] = useState<Announcement>({
    ...emptyAnnouncement,
    uuid: uuid4(),
    date: Date.now(),
  })

  const [validationErrors, setValidationErrors] = useState<validationError[]>(
    []
  )
  useEffect(() => {
    const newValidationErrors: validationError[] = []

    if (announcement.date == null)
      newValidationErrors.push({
        property: 'date',
        type: 'isRequired',
      })

    if (announcement.message.length > announcementMessageMaxSize)
      newValidationErrors.push({
        property: 'message',
        type: 'length',
      })

    console.log(
      'newValidationErrors',
      JSON.stringify({ newValidationErrors, announcement })
    )
    setValidationErrors(newValidationErrors)
  }, [announcement])

  const [saveInProgress, setSaveInProgress] = useState(false)
  const saveAnnouncement = () => {
    setSaveInProgress(true)

    fetch(
      `https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/announcement-add`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthorizationHeader(),
        },
        body: JSON.stringify({
          announcement,
        }),
      }
    )
      .then(() => {
        dispatch(setIsAnnouncementsRequested(false))
        setTimeout(() => {
          dispatch(setDestinationView({ destinationView: 'announcement-list' }))
        }, 1)
      })
      .catch((err) => {
        console.warn(`fetch announcement-add failed: `, err)
      })
  }

  return (
    <div className="announcement-add">
      {saveInProgress ? (
        <div className="save-in-progress">
          <LoadingSpinner color="dark" />
          {localization.text(
            'announcement-save-in-progress',
            'De aankondiging word momenteel opgeslagen.'
          )}
        </div>
      ) : (
        <>
          <DateInput
            label={localization.text('date', 'Datum')}
            isReadOnly={saveInProgress}
            onChange={(newValue) => {
              if (newValue !== undefined)
                setAnnouncement((previous) => ({
                  ...previous,
                  date: newValue,
                }))
            }}
            value={announcement.date}
            isValid={!validationErrors.some((ve) => ve.property === 'date')}
            helperText={
              validationErrors.find((ve) => ve.property === 'date')?.type ===
              'isRequired'
                ? localization.text('date-missing', 'Geef een geldige datum in')
                : undefined
            }
          />

          <TextInput
            label={localization.text('title', 'Titel')}
            isReadOnly={saveInProgress}
            onChange={(value) => {
              setAnnouncement((previous) => ({ ...previous, title: value }))
            }}
            value={announcement.title}
            isValid={!validationErrors.some((ve) => ve.property === 'title')}
          />

          <HtmlTextInput
            label={localization.text('message', 'Bericht')}
            isReadOnly={saveInProgress}
            onChange={(value) => {
              setAnnouncement((previous) => ({ ...previous, message: value }))
            }}
            value={announcement.message}
            isValid={!validationErrors.some((ve) => ve.property === 'message')}
            helperText={
              validationErrors.find((ve) => ve.property === 'message')?.type ===
              'length'
                ? localization.text(
                    'message-too-long',
                    'Dit bericht is te lang. Mogelijks door te grote afbeeldingen? Maximum 300kb text + afbeeldingen.'
                  )
                : undefined
            }
          />

          <div className="buttons">
            {validationErrors.length === 0 && !saveInProgress ? (
              <Button
                importance={'primary'}
                text={localization.text(
                  'safe-add-button',
                  'Voeg aankondiging toe'
                )}
                onClick={saveAnnouncement}
              />
            ) : null}
          </div>
        </>
      )}
    </div>
  )
}

interface validationError {
  property: string
  type: 'isRequired' | 'format' | 'length'
}
